var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33331 7H14.6666",
    stroke: "url(#paint0_linear_110_105)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.83331 1.16663L14.6666 6.99996L8.83331 12.8333",
    stroke: "url(#paint1_linear_110_105)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_105",
    x1: 12.6666,
    y1: 7,
    x2: 12.5931,
    y2: 8.4519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "black"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "black"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_105",
    x1: 13.7916,
    y1: 1.16663,
    x2: 5.66903,
    y2: 7.18338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "black"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.3561810836fbc35ccf20fa54ae188929.svg";
export { ForwardRef as ReactComponent };